<template>
  <div class="config-page">
    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="config-index">
      <div v-if="devdata">
        <van-nav-bar left-arrow class="crystal-nav" @click-left="onClickLeft">
          <template #left>
            <van-icon name="arrow-left" size="20px" color="#475569" />
          </template>
          <template #title>
            <div class="nav-title-wrap">
              <span class="nav-devname">{{ devdata.udname }}</span>
              <span class="nav-did">参数设置</span>
            </div>
          </template>
        </van-nav-bar>

        <div class="content-area">
          <div class="config-card">
            <div class="config-card-header">
              <div class="header-dot"></div>
              <span>参数设置</span>
              <button class="save-btn" @click="send_config">保存参数</button>
            </div>
            <div class="config-card-body">
              <van-form label-width="50%">
                <div class="config-field">
                  <span class="config-field-label">自动恢复</span>
                  <van-switch v-model="auto_recovery" size="20" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">工作模式</span>
                  <van-radio-group v-model="work_mode" direction="horizontal" class="config-radio">
                    <van-radio :name="0">自动保护</van-radio>
                    <van-radio :name="1">手动控制</van-radio>
                  </van-radio-group>
                </div>
                <div class="config-divider"></div>
                <div class="config-field config-field-stepper">
                  <div class="stepper-label-wrap">
                    <span class="config-field-label">断电保护延迟(秒)</span>
                  </div>
                  <van-stepper v-model="leak_on_delay" :min="1" :max="30" :step="1" integer />
                </div>
                <div class="config-divider"></div>
                <div class="config-field config-field-stepper">
                  <div class="stepper-label-wrap">
                    <span class="config-field-label">断电恢复延迟(秒)</span>
                  </div>
                  <van-stepper v-model="leak_off_delay" :min="1" :max="30" :step="1" integer />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">蜂鸣报警</span>
                  <van-switch v-model="buzzer_enable" size="20" />
                </div>
                <div class="config-divider"></div>
                <div class="config-field">
                  <span class="config-field-label">微信报警通知</span>
                  <van-switch v-model="wechat_alarm" size="20" />
                </div>
              </van-form>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: "KA1Config",
  data() {
    return {
      devdata: null,
      did: this.$route.query.did,
      auto_recovery: false,
      work_mode: 0,
      leak_on_delay: 2,
      leak_off_delay: 2,
      buzzer_enable: true,
      wechat_alarm: true,
    };
  },
  mounted() {
    this.GetDevData(this.did);
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    GetDevData(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.devdata = response.data;
            this.auto_recovery = this.devdata.config.auto_recovery == 1;
            this.work_mode = this.devdata.config.work_mode != null ? this.devdata.config.work_mode : 0;
            this.leak_on_delay = this.devdata.config.leak_on_delay != null ? this.devdata.config.leak_on_delay : 2;
            this.leak_off_delay = this.devdata.config.leak_off_delay != null ? this.devdata.config.leak_off_delay : 2;
            this.buzzer_enable = this.devdata.config.buzzer_enable != null ? (this.devdata.config.buzzer_enable == 1) : true;
            this.wechat_alarm = this.devdata.config.wechat_alarm != null ? (this.devdata.config.wechat_alarm == 1) : true;
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        });
    },
    send_config() {
      const qs = require("qs");
      var buf = {
        auto_recovery: this.auto_recovery ? 1 : 0,
        work_mode: this.work_mode,
        leak_on_delay: this.leak_on_delay,
        leak_off_delay: this.leak_off_delay,
        buzzer_enable: this.buzzer_enable ? 1 : 0,
        wechat_alarm: this.wechat_alarm ? 1 : 0,
      };
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.did,
          d_type: "KA-1",
          config: JSON.stringify(buf),
        }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$notify({ type: "success", message: "设置成功！" });
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$notify({ type: "danger", message: "设置失败！" });
          }
          this.GetDevData(this.did);
        })
        .catch((error) => {
          this.GetDevData(this.did);
          this.$notify({ type: "danger", message: "设置失败！" });
        });
    },
    onReflash() { this.devrefresh(); },
    devrefresh() {
      this.isLoading = true;
      const qs = require("qs");
      var databuf = JSON.stringify({ a: 2 });
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KA-1",
          config: databuf,
        }))
        .then((response) => {
          this.isLoading = false;
          if (response.data.error_code === 0) {
            this.GetDevData(this.did);
          }
        })
        .catch((error) => { this.isLoading = false; });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}
</style>

<style scoped>
.config-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.config-index {
  background: transparent !important;
  padding-bottom: 20px;
  min-height: 100vh;
  min-height: 100dvh;
}

.content-area {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.config-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.config-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.header-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2dd4bf;
  flex-shrink: 0;
}

.config-card-header span {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.save-btn {
  height: 30px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
  box-shadow: 0 2px 8px rgba(45, 212, 191, 0.25);
  transition: transform 0.15s;
  flex-shrink: 0;
}

.save-btn:active { transform: scale(0.95); }

.config-card-body {
  padding: 4px 0;
}

.config-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  min-height: 40px;
}

.config-field-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

:deep(.van-switch--on) {
  background: #2dd4bf !important;
}

.config-radio {
  display: flex;
  gap: 6px;
}

.config-radio .van-radio__label {
  font-size: 13px;
  color: #475569;
}

.config-radio .van-radio__icon--checked .van-icon {
  background-color: #2dd4bf;
  border-color: #2dd4bf;
}

.config-field-stepper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  min-height: 40px;
}

.stepper-label-wrap {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  margin-right: 12px;
  min-width: 0;
}

.stepper-desc {
  font-size: 11px;
  color: #94a3b8;
  line-height: 1.3;
}

:deep(.van-stepper) {
  flex-shrink: 0;
}

:deep(.van-stepper__minus),
:deep(.van-stepper__plus) {
  color: #2dd4bf;
  border-color: #2dd4bf;
}

:deep(.van-stepper__minus:active),
:deep(.van-stepper__plus:active) {
  background-color: #ccfbf1;
}

:deep(.van-stepper__input) {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
}
</style>
